import React from 'react';
import { PERMISSION } from 'pages/CustomerLead/utils/constants';

const CustomerLead = React.lazy(() => import('pages/CustomerLead/pages/CustomerLead'));
const CustomerLeadAdd = React.lazy(() => import('pages/CustomerLead/pages/CustomerLeadAdd'));

const customerLeadRoute = [
  ...[
    { path: '/lead-individual', name: 'Lead cá nhân' },
    { path: '/lead-business', name: 'Lead doanh nghiệp' },
  ].flatMap(({ path, name }) => [
    { path, exact: true, name, function: PERMISSION.VIEW, component: CustomerLead },
    { path: `${path}/add`, exact: true, name: `Thêm mới ${name.toLowerCase()}`, function: PERMISSION.ADD, component: CustomerLeadAdd },
    { path: `${path}/edit/:data_leads_id`, exact: true, name: `Chỉnh sửa ${name.toLowerCase()}`, function: PERMISSION.EDIT, component: CustomerLeadAdd },
    { path: `${path}/detail/:data_leads_id`, exact: true, name: `Chi tiết ${name.toLowerCase()}`, function: PERMISSION.VIEW, component: CustomerLeadAdd },
  ]),
  {
    path: '/customer-lead',
    exact: true,
    name: 'Danh sách khách hàng tiềm năng',
    function: PERMISSION.VIEW,
    component: CustomerLead,
  },
  {
    path: '/customer-lead/add',
    exact: true,
    name: 'Thêm mới khách hàng tiềm năng',
    function: PERMISSION.ADD,
    component: CustomerLeadAdd,
  },
  {
    path: '/customer-lead/edit/:data_leads_id',
    exact: true,
    name: 'Chỉnh sửa khách hàng tiềm năng',
    function: PERMISSION.EDIT,
    component: CustomerLeadAdd,
  },
  {
    path: '/customer-lead/detail/:data_leads_id',
    exact: true,
    name: 'Chi tiết khách hàng tiềm năng',
    function: PERMISSION.VIEW,
    component: CustomerLeadAdd,
  },
];

export default customerLeadRoute;
